const caseSetup = {
  pageTitle: "Case Setup",
  pageDescription:
    "Users who have been granted a case manager role can create a new case in the {{applicationHeading}}.",
  caseDetails: {
    title: "Case Details",
    description:
      "The Case Name should be a reference for the entire case. Once created the Case Short Name will be used for report names, creditor and claim reference numbers, and should not be changed. Ideally the Case Short Name should be less than 8 characters.  The Case Time Zone will be used to timestamp all logged entries, and should reflect the primary timezone for the administration of the case.",
    caseIdentifiersEnglish: "Case Identifiers (English)",
    formLabels: {
      caseName: "Case Name",
      caseNameFrench: "Case Name (French)",
      caseDescription: "Case Description",
      caseDescriptionFrench: "Case Description (French)",
      shortName: "Case Short Name (ideally < 8 character)",
      includeInFrench:
        "I want to include case identifiers in French on the form",
      caseConfiguration: "Case Configuration",
      timeZone: "Case Time Zone (all logged times will use this timezone)",
      notificationRecipients: "Notification Recipients",
    },
    validationMessage:
      "Please complete all required fields to continue. {{filedNames}} cannot be left blank.",
    caseNameValidation: "The case name cannot be empty or contain only spaces.",
    emailValidationCount: "You can only enter a maximum of 5 emails.",
    emailSeperationValidation: "Please separate emails using semicolons.",
    emailValidation:
      "Please enter upto 5 valid EY related email(s) separated by semicolons.",
  },
  debtorInformation: {
    title: "Debtor Information",
    description:
      "Please use the proper legal name for each debtor. For cases with multiple debtors, enter each debtor separately. Additional debtors can be added later.",
    formLabels: {
      addDebtors: "Add Debtors",
      debtorName: "Debtor Name",
      description: "Debtor Description",
      addDebtor: "Add a Debtor",
      legalNameDebtor: "Legal Debtor Name",
    },
    deleteConfirmationHeader: "Remove Debtor",
    deleteConfirmationDescription:
      "Do you want to remove the  debtor - {{debtorName}}?",

    validationMessage:
      "Please complete all required fields to continue.{{filedNames}} cannot be left blank.",
    requiredFields: "At least one Debtor is reqired",
    debtorName: "Debtor Name is required.",
    debtorDescription: "Debtor Description is required.",
  },
  currencyConfiguration: {
    title: "Currency Configuration",
    description:
      "Currencies are used to enter claims in their original currency. Each case has a default currency, and all other currencies will be converted into the default currency by multiplying the currency by the currency's Exchange Rate to yield the equivalent default currency amount. The default currency for the case cannot be changed. The Decimal point is used for display purposes, but the system will record values with more decimals as required. Recommend the use of ISO 4217 Currency codes (https://www.six-group.com/dam/download/financial-information/data-center/iso-currrency/lists/list-one.xls). Currencies can also be used for identification of Crypto currencies. When used for crypo currencies, set the decimal places to an appropriate value such as 8. Currencies can also be used for claims on bond issues, where it is desirable to enter the face amount of the bond, and use the Exchange Rate to apply a consistent conversion into the default currency for the case.",
    defaultCurrency: "Add Default Currency",
    additionalCurrency: "Add Additonal Currency",
    validationMessage:
      "Please complete all required fields to continue.{{filedNames}} cannot be left blank or invaid Number.",
    defaultCurrencyReq: "Default Currency is Required",
    CurrencyReq: "Currency is Required",
    exchangeRateReq: "Exchange Rate is Required",
    exchangeRateNumber: "Exchange Rate is a number",
    defaultExchangeRateReq: "Default Exchange Rate is Required",
    defaultExchangeRateNumber: "Default Exchange Rate is a number",
    defaultDecimalPoint: "Default Decimal Place is Required",
    defaultDecimalPointNumber:
      "Default Decimal Place is a number between 0 to 8",
    decimalPointReq: "Decimal Place is Required",
    decimalPointNumberReq: "Decimal Place is a number between 0 to 8",
    formLabels: {
      defaultCurrencyName: "Default Currency Name",
      exchangeRate: "Exchange Rate",
      decimalPoint: "Decimal Places",
      currencyName: "Currency Name",
      remove: "Remove",
      addAnother: "Add Another",
      additionalCurrency: "Additional Currency",
      description: "Description",
    },
  },
  reviewTab: {
    title: "Review",
    description:
      "Please review and confirm the details of the new case. Once created the Case Short Name will be used for report names, creditor and claim reference numbers, and should not be changed.",
    validationMessage:
      "Please ensure all required fields are filled and input format is valid.",
  },

  tabPanneletails: {
    tab1: "Case Details",
    tab2: "Debtor Information",
    tab3: "Currency configuration",
  },
};

export default caseSetup;
